import { useEffect, useRef } from "react"

import "./printableSection.scss"

export default function PrintableSection({
  children,
  sectionTitle = "",
  currentItemCount,
  totalItemCount,
  subjectTitle = "",
  subjectSubtitle = "",
  scaleRatio = 1,
  hideHeader = false,
}: {
  children: React.ReactNode
  sectionTitle?: string
  currentItemCount?: number
  totalItemCount?: number
  subjectTitle?: string
  subjectSubtitle?: string
  scaleRatio?: number
  hideHeader?: boolean
}) {
  const sectionRef = useRef<HTMLDivElement>(null)

  const setScaleRatio = () => {
    ;(sectionRef.current as HTMLElement)?.style.setProperty("--scale-ratio", scaleRatio + "px")
  }

  useEffect(() => {
    if (!sectionRef.current) {
      return
    }
    setScaleRatio()
  }, [scaleRatio, sectionRef])

  return (
    <div className="section" ref={sectionRef}>
      {!hideHeader && (
        <>
          <div className="section-name">
            <span className="section-title-main">{sectionTitle}</span>
            <span className="item-count-text">
              {currentItemCount !== undefined && totalItemCount !== undefined
                ? `${currentItemCount} / ${totalItemCount}`
                : ""}
            </span>
          </div>
          {subjectTitle && subjectSubtitle && (
            <div className="section-title">
              <h3 className="section-title-main">{subjectTitle}</h3>
              <h4 className="section-title-sub">{subjectSubtitle}</h4>
            </div>
          )}
        </>
      )}
      {children}
    </div>
  )
}
